import {useRef} from 'react'

import {ResponsiveMedia, useContainerQuery} from '@sdox/ui'

import {xcMediaRefToMediaItem} from '../../'

import type {ResponsiveMediaType} from '@sdox/ui'
import type {XcNwBlock_BlockMediaSingleImageType_Fragment} from '@sdox/api'

export const BlockMediaSingleImageType = (props: XcNwBlock_BlockMediaSingleImageType_Fragment) => {
  const {pullout, image, imageMobile} = props

  const containerRef = useRef<HTMLDivElement>(null)
  const isDesktop = useContainerQuery({
    containerRef,
    // 704px and 563px align with the break point of the chapter opener block
    width: pullout ? 704 : 563,
  })
  const media: ResponsiveMediaType = {
    desktop: xcMediaRefToMediaItem(image),
    mobile: imageMobile ? xcMediaRefToMediaItem(imageMobile) : undefined,
  }

  return (
    <div ref={containerRef}>
      <ResponsiveMedia
        media={media}
        currentScreenSize={isDesktop ? 'desktop' : 'mobile'}
        classNames={{
          image: 'no-pullout-rounded-md pullout-rounded-lg w-full object-cover',
          video: 'no-pullout-rounded-md pullout-rounded-lg w-full',
        }}
      />
    </div>
  )
}
